export const MODULES = [
  { key: "climaOld", label: "ECO", icon: "list", tip: null },
  { key: "clima", label: "CL7", icon: "ac_unit", tip: null },
  {
    key: "frp",
    label: "FRP v21",
    icon: "blur_on",
    tip: "Factores de riesgo - v2021",
  },
  {
    key: "frpNew",
    label: "FRP v23",
    icon: "blur_on",
    tip: "Factores de riesgo - v2023",
  },
  { key: "cultura", label: "Cultura", icon: "stream", tip: null },
  {
    key: "leader",
    label: "Liderazgo PHD",
    icon: "stars",
    tip: "Liderazgo PHD",
  },
];

export const DIAGNOSIS_ROUTES = {
  climaOld: {
    cliente: "datamenu/listdata",
    admin: "datamenu/listdata",
    role: ["cliente"],
  },
  clima: {
    cliente: "/clima7/home",
    admin: "/climan",
    role: ["free"],
  },
  frp: {
    cliente: "/listview",
    admin: "/listview",
    role: ["cliente"],
  },
  frpNew: {
    cliente: "/frp",
    admin: "/frp",
    role: ["frp"],
  },
  cultura: {
    cliente: "/cultura",
    admin: "/cultura",
    role: ["cliente"],
  },
  leader: {
    cliente: "/lider",
    admin: "/lider",
    role: ["lider", "ghumana"],
  },
};

export const SORTABLE_COLUMNS = [
  "nombre",
  "climaOld",
  "clima",
  "frp",
  "frpNew",
  "cultura",
  "leader",
];

export const EMPTY_HEADER = Object.freeze({
  companies: null,
  processTotal: null,
  modules: Object.freeze({
    climaOld: null,
    clima: null,
    frp: null,
    frpNew: null,
    cultura: null,
    leader: null,
  }),
  companiesValidate: null,
  rangeDates: null,
});

const OBJECT_ID_PATTERN = /^[0-9a-fA-F]{24}$/;

export const normalizeSearch = (text) => String(text || "").trim();

export const isValidCompanyId = (id) =>
  typeof id === "string" && OBJECT_ID_PATTERN.test(id);

export const getModule = (key) => {
  for (let i = 0; i < MODULES.length; i += 1) {
    if (MODULES[i].key === key) return MODULES[i];
  }
  return null;
};

export const buildSortParams = (sortModel) => {
  const entry =
    Array.isArray(sortModel) && sortModel.length ? sortModel[0] : null;
  if (
    !entry ||
    SORTABLE_COLUMNS.indexOf(entry.colId) === -1 ||
    (entry.sort !== "asc" && entry.sort !== "desc")
  ) {
    return {};
  }
  return { sortBy: entry.colId, sortDir: entry.sort };
};

export const buildCompaniesParams = ({
  startRow,
  limit,
  search,
  diagnostic,
  pinned,
  sortModel,
}) => {
  const params = { startRow, limit };
  const normalized = normalizeSearch(search);
  if (normalized) params.search = normalized;
  if (diagnostic) params.diagnostic = diagnostic;
  if (pinned) params.pinned = pinned;
  const sort = buildSortParams(sortModel);
  if (sort.sortBy) {
    params.sortBy = sort.sortBy;
    params.sortDir = sort.sortDir;
  }
  return params;
};

export const parseCompaniesBlock = (data) => {
  if (
    !data ||
    !Array.isArray(data.rows) ||
    typeof data.total !== "number"
  ) {
    throw new Error("Invalid companies block response");
  }
  const pinned =
    data.pinned && typeof data.pinned === "object" && !Array.isArray(data.pinned)
      ? data.pinned
      : null;
  return { rows: data.rows, total: data.total, pinned };
};

const toNumberOrNull = (value) =>
  typeof value === "number" && isFinite(value) ? value : null;

export const parseHeader = (data) => {
  const source = data && typeof data === "object" ? data : {};
  return {
    companies: toNumberOrNull(source.companies),
    processTotal: toNumberOrNull(source.processTotal),
    modules: {
      climaOld: toNumberOrNull(source.climaOld),
      clima: toNumberOrNull(source.clima),
      frp: toNumberOrNull(source.frp),
      frpNew: toNumberOrNull(source.frpNew),
      cultura: toNumberOrNull(source.cultura),
      leader: toNumberOrNull(source.leader),
    },
    companiesValidate: Array.isArray(source.companiesValidate)
      ? source.companiesValidate
      : null,
    rangeDates:
      source.rangeDates && typeof source.rangeDates === "object"
        ? source.rangeDates
        : null,
  };
};

export const escapeHtml = (text) =>
  String(text === null || text === undefined ? "" : text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const getCompanyInitials = (name) => {
  const source = String(name || "").trim();
  if (!source) return "?";
  const words = source.split(/\s+/);
  const first = words[0].charAt(0);
  const second = words.length > 1 ? words[1].charAt(0) : "";
  return (first + second).toUpperCase();
};

export const formatNumber = (value) =>
  value === null || value === undefined ? "-" : Number(value).toLocaleString();

export const formatLongDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleDateString("es", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const describeFilters = (search, moduleKey, year) => {
  const parts = [];
  if (search) parts.push(`«${search}»`);
  const mod = moduleKey ? getModule(moduleKey) : null;
  if (mod) parts.push(`Módulo: ${mod.label}`);
  if (year) parts.push(`Año ${year}`);
  return parts.join(", ");
};

export const isYearDisabled = (date, rangeDates, now) => {
  const year = date.getFullYear();
  if (year > now.getFullYear()) return true;
  if (!rangeDates || !rangeDates.minDate) return false;
  const min = new Date(rangeDates.minDate);
  return !isNaN(min.getTime()) && year < min.getFullYear();
};

export const resolveDiagnosisRoute = (key, tokenUser) => {
  const entry = DIAGNOSIS_ROUTES[key];
  if (!entry || !tokenUser) return null;
  if (tokenUser.admin) return entry.admin;
  const allowed = entry.role.some((claim) => !!tokenUser[claim]);
  if (!allowed) return null;
  return tokenUser.cliente ? entry.cliente : entry.admin;
};

export const getLastProcess = (row, key) => {
  const last = row ? row[key + "ProcessLast"] : null;
  return last && (last.nombre || last.name) ? last : null;
};

export const getDiagnosisTooltipMode = (row, key) => {
  if (!row) return null;
  const count = Number(row[key]) || 0;
  if (count === 0) return "create";
  return getLastProcess(row, key) ? "last" : null;
};

export const renderSkeleton = (width) =>
  `<div class="em-skeleton-bar" style="width: ${width || "60%"}"></div>`;

export const renderCompanyCell = (params) => {
  if (!params.data) return renderSkeleton("60%");
  const company = params.data;
  const parent = params.context && params.context.componentParent;
  const selectedId = parent && parent.pinnedId;
  const pinned =
    !!(params.node && params.node.rowPinned === "top") ||
    (!!selectedId && company._id === selectedId);
  const subParts = [];
  if (company.nit) {
    subParts.push(`NIT ${escapeHtml(company.nit)}`);
  }
  if (pinned) {
    subParts.push('<span class="em-pin-tag">Seleccionada</span>');
  }
  const sub = subParts.length
    ? `<div class="em-company-sub">${subParts.join(" · ")}</div>`
    : "";
  return `
    <div class="em-company">
      <span class="em-avatar">${escapeHtml(
        getCompanyInitials(company.nombre),
      )}</span>
      <div class="em-company-text">
        <div class="em-company-name">${escapeHtml(company.nombre)}</div>
        ${sub}
      </div>
    </div>
  `;
};

export const renderDiagnosisCell = (params) => {
  if (!params.data) return renderSkeleton("28px");
  const key = params.colDef.colId;
  const value = params.data[key];
  const mod = getModule(key);
  if (!(Number(value) > 0) || !mod) {
    return '<div class="em-dx em-dx--empty"><span class="em-dx-dot"></span><i class="material-icons em-dx-add">add</i></div>';
  }
  return `<div class="em-dx"><span class="em-dx-icon"><i class="material-icons">${mod.icon}</i></span><span class="em-dx-count">${escapeHtml(
    value,
  )}</span></div>`;
};

export const renderUsersCell = (params) => {
  if (!params.data) return renderSkeleton("24px");
  return `<div class="em-users">${escapeHtml(params.data.users)}</div>`;
};



// WEBPACK FOOTER //
// ./src/components/empresas/helpers.js